import { Button, Flex } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';

import { useIsBusy } from '@jane/bloom/hooks/navigation/useIsBusy';
import { formatProductCount } from '@jane/bloom/utils/strings/formatProductCount';

import styles from './filterActions.module.css';

type FilterActionsProps = {
  availableProductsCount?: number;
  className?: string;
  fullButtons?: {
    clear?: boolean;
    show?: boolean;
  };
  handleClearAll: () => void;
  handleClose?: () => void;
  sticky?: boolean;
};

export function FilterActions({
  availableProductsCount,
  className,
  fullButtons = {},
  handleClearAll,
  handleClose,
  sticky,
}: FilterActionsProps) {
  const isLoading = useIsBusy();
  const [isClearing, setIsClearing] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsClearing(false);
    }
  }, [isLoading]);

  return (
    <Flex
      className={clsx(
        styles['actions'],
        { [styles['actions--sticky']]: sticky },
        className
      )}
      flexDirection="row"
      justifyContent="space-between"
      gap={16}
    >
      <Button
        className={styles['text']}
        full={fullButtons.clear}
        label="Clear all"
        onClick={() => {
          handleClearAll();
          setIsClearing(true);
        }}
        loading={isClearing}
        variant="tertiary"
      />
      <Button
        className={styles['text']}
        disabled={availableProductsCount === 0}
        full={fullButtons.show}
        label={
          availableProductsCount
            ? formatProductCount(availableProductsCount, 'Show')
            : 'Show products'
        }
        loading={isLoading && !isClearing}
        onClick={handleClose}
        variant="primary"
      />
    </Flex>
  );
}
